import { useSelector } from 'react-redux';
import { GALAXY_ROLES, selectGalaxyRole } from 'selectors';

// galaxy-server maps PUT ai_api/teams/:teamId/ai-enabled to SALES_CSM, which
// these roles reach.
const TOGGLE_ROLES: string[] = [GALAXY_ROLES.SALES, GALAXY_ROLES.CSM, GALAXY_ROLES.DEV];

// PUT ai_api/teams/:teamId/ai-blocked is DEV only: the block overrides the
// SALES_CSM toggle.
const BLOCK_ROLES: string[] = [GALAXY_ROLES.DEV];

/**
 * Which AI suggestions controls the signed-in user may use. For the On/Off
 * toggle, a user whose role cannot be read is let through: galaxy-server
 * decides and its refusal shows as the error message. Block/Unblock needs a
 * recognized admin role.
 */
export const useAiSuggestionsAccess = () => {
  const role = useSelector(selectGalaxyRole);
  return {
    canToggle: role === undefined || TOGGLE_ROLES.includes(role),
    canBlock: role !== undefined && BLOCK_ROLES.includes(role),
  };
};

export default useAiSuggestionsAccess;
